import React, {useEffect, useState} from "react";
import {
    ColumnDef,
    flexRender,
    getCoreRowModel,
    useReactTable,
    HeaderGroup,
    getFilteredRowModel, getFacetedRowModel, getFacetedUniqueValues, getFacetedMinMaxValues, ColumnFiltersState
} from "@tanstack/react-table";
import {LabelKeyObject} from "react-csv/lib/core";
import {CSVExport, Filter} from "../third-party/react-table";
import {TableDataProps} from "../../types/table";

import ScrollX from 'components/ScrollX';
import MainCard from 'components/MainCard';
import Paper from "@mui/material/Paper";
import { Table, TableBody, TableContainer, TableHead, TextField} from "@mui/material";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import {Add} from "iconsax-react";
import Typography from "@mui/material/Typography";
import {FormattedMessage} from "react-intl";

interface ReactTableProps<T> {
    columns: ColumnDef<T, unknown>[];
    data: T[];
    striped?: boolean;
    title?: string;
    modalToggler: () => void
    onFilterChange?: (state: ColumnFiltersState) => void
    manualFiltering?: boolean
}


export default function BasicTableCustom({
                                       columns,
                                       data,
                                       striped,
                                       title,
                                       modalToggler,
                                       onFilterChange,
                                       manualFiltering
                                   }: ReactTableProps<any>) {
    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);

    const table = useReactTable({
        data,
        columns,
        state: {columnFilters},
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getFacetedRowModel: getFacetedRowModel(),
        getFacetedUniqueValues: getFacetedUniqueValues(),
        getFacetedMinMaxValues: getFacetedMinMaxValues(),
        onColumnFiltersChange: setColumnFilters,
        manualFiltering: manualFiltering === undefined ? false : manualFiltering,
    });

    useEffect(() => {
        if (onFilterChange ) {
            onFilterChange(columnFilters)
        }
    }, [columnFilters]);


    let headers: LabelKeyObject[] = [];
    table.getAllColumns().map((columns) =>
        headers.push({
            label: typeof columns.columnDef.header === 'string' ? columns.columnDef.header : '#',
            // @ts-ignore
            key: columns.columnDef.accessorKey
        })
    );


    return (
        <MainCard
            content={false}
        >
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{padding: 3}}>
                <Typography variant="h6" fontWeight="bold">{title}</Typography>

            </Stack>
            <ScrollX>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            {table.getHeaderGroups().map((headerGroup: HeaderGroup<any>) => (
                                <TableRow key={headerGroup.id}>
                                    {headerGroup.headers.map((header) => (
                                        <TableCell key={header.id} {...header.column.columnDef.meta} sx={ {...(header.column.columnDef.minSize && {minWidth: header.column.columnDef.minSize})} }>
                                            {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableHead>
                        <TableHead>
                            {table.getHeaderGroups().map((headerGroup: HeaderGroup<any>) => (
                                <TableRow key={headerGroup.id}>
                                    {headerGroup.headers.map((header) => (
                                        <TableCell key={header.id} {...header.column.columnDef.meta}>
                                            {header.column.getCanFilter() &&
                                                <Filter column={header.column} table={table}/>}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableHead>
                        <TableBody {...(striped && {className: 'striped'})}>
                            {table.getRowModel().rows.map((row) => (
                                <TableRow key={row.id}>
                                    {row.getVisibleCells().map((cell) => (
                                        <TableCell key={cell.id} {...cell.column.columnDef.meta}>
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </ScrollX>
        </MainCard>
    );
}